import React from 'react';
import './style.scss';
import {hashHistory} from 'react-router';

export const Header = (props) => {
   const nextPage = () => {
       if(props.step2)
       {
           props.saveHtml();
       }
       hashHistory.push(props.nextPageLink);
    }
    let button;
    let backbutton;
    if(props.download)
    {
        button =  <button className="button btn-forward has-dark-shadow" onClick={(e) => props.downloadMethod(e)}>Skicka offertunderlag</button>
       
    }else if(props.activeNextButton){
        button = <button className="button btn-forward has-dark-shadow" onClick={() => nextPage()}>Nästa steg</button>
    }else {
        button = <button className="button btn-back" disabled>Nästa steg</button>
    }
    if(props.hideButton)
    {
        backbutton = "";
    }else {
        backbutton = <button className="button btn-back" onClick={() => hashHistory.goBack()}>Tillbaka</button>
    }
    return (
        <div className="hero header-navigate">
            <div className="hero-body header-second-top has-bottom-border has-shadow is-paddingless">
                <div className="container is-fluid">
                    <div className="columns is-desktop is-vcentered">
                        <div className="column is-half">
                            <h2>{props.title}</h2>
                            <h1>{props.subtitle}</h1>
                        </div>
                        <div className="column is-half">
                            { button }
                            {backbutton}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Components/Header/index.js